import React, {useContext} from 'react';
import './ConfirmGuestOrderPopup.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import ErrorIcon from 'new-images/error.svg';
import {Message} from 'compositions/message/Message';
import {Button} from "elements/button/Button";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";



export const ConfirmGuestOrderPopup = ({title, description, onOverlayClick, onYesClick, onNoClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onNoClick}>
			{getSafeTranslation('ConfirmationPopup.cancelButtonCaption', translations)}
		</Button>}
		rightControl={<Button isAutoWidth onClick={onYesClick}>{
			getSafeTranslation('ConfirmationPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="confirmation">
			<Message
				icon={ErrorIcon}
				title={title}
				description={description}
			/>
		</div>
	</DrawerPopup>
}
